export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";